// incidentTemplates.js
import React from "react";

/**
 * Master template set for every subtype.
 * Each entry has datasetTitle, datasetDescription, attributeTitle, attributeDescription.
 */

export const metrics_units = {
  "Fill Rate": "%",
  "Row Count": "%",
  "Recency": "",
  "Data Outlier": "%",
  "Data Drift": "%",
  "Data Type Consistency": "%",
  "Categorical Encode": "%",
  "Normalization Consistency": "%",
  "Boolean Conformity": "%",
  "Credit Card Conformity": "%",
  "Date Conformity": "%",
  "Email Conformity": "%",
  "Gender Conformity": "%",
  "HTTP Conformity": "%",
  "IP Conformity": "%",
  "SSN Conformity": "%",
  "URL Conformity": "%",
  "partition identifier incorrect": "",
  "dataset empty": "",
  "New attribute added": "",
  "Existing attribute deleted": "",
  "Attribute datatype changed": "",
  "unable to reach host": "",
  "dataset deleted": "",
  "incorrect credentials": "",
  "schema not found": "",
  "Failed Runs": "",
  "Failed Stages": ""
};


export const chart_metrics_units = {
  "Fill Rate": "%",
  "Row Count": "%",
  "Recency": "refreshes",
  "Data Outlier": "%",
  "Data Drift": "%",
  "Data Type Consistency": "%",
  "Categorical Encode": "%",
  "Normalization Consistency": "%",
  "Boolean Conformity": "%",
  "Credit Card Conformity": "%",
  "Date Conformity": "%",
  "Email Conformity": "%",
  "URL Conformity": "%",
  "Gender Conformity": "%",
  "HTTP Conformity": "%",
  "IP Conformity": "%",
  "SSN Conformity": "%",
  "partition identifier incorrect": "",
  "dataset empty": "",
  "New attribute added": "",
  "Existing attribute deleted": "",
  "Attribute datatype changed": "",
  "unable to reach host": "",
  "dataset deleted": "",
  "incorrect credentials": "",
  "schema not found": "",
  "Failed Runs": "",
  "Failed Stages": ""
};


// "x - source_names_info[""attribute_name""]
// y - source_names_info[""dataset_name""]
// z - metrics_value
// w - reference dataset name"


export const templates = {
  "Fill Rate": {
    "datasetTitle": "Missing Data: <z>%",
    "attributeTitle": "Missing Data: <z>%",
    "descriptionDataset": "The dataset <y> has only <100-z>% of its values filled and <z>% of the data is missing or empty. This may affect the accuracy and reliability of the dataset.",
    "descriptionAttribute": "The attribute <x> in the dataset <y> has only <100-z>% of its values filled and <z>% of the data is missing or empty. This may impact the accuracy of the downstream pipelines, models, analytics and KPIs."
  },
  "Row Count": {
    //"datasetTitle": "<z%> <increase/decrease> in number of rows in dataset <y>",
    "datasetTitle": "Number of new rows increased by <z>%",
    "attributeTitle": null,
    "descriptionDataset": "In the last <y> refreshes, the average number of new rows was <z>. In the current refresh, the number of new rows in <y> has <increase_decrease> by <z%>.",
    "descriptionAttribute": null
  },
  "Recency": {
    "datasetTitle": "Number of missed refreshes: <z>",
    "attributeTitle": null,
    "descriptionDataset": "The dataset <y> has missed <z> scheduled refreshes. This indicates that the dataset is not being refreshed on time and the data may be outdated.",
    "descriptionAttribute": null
  },
  "Data Outlier": {
    "datasetTitle": "Outliers in Data: <z>%",
    "attributeTitle": "Outliers in Data: <z>%",
    "descriptionDataset": "The dataset <y> has <z%> of values that are significantly different from the rest of the data. These unusual values may affect the quality and reliability of the dataset.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values that are considerably different from the rest of the data. These unusual values may affect the quality and reliability of the attribute."
  },
  "Data Drift": {
    "datasetTitle": "Drift in Data: <z>%",
    "attributeTitle": "Drift in Data: <z>%",
    "descriptionDataset": "<z%> of data in the dataset <y> has significantly changed compared to the previous refreshes. This variation indicates a drift in data, which may impact the accuracy of downstream pipelines, models, analytics and KPIs.",
    "descriptionAttribute": "The attribute <x> in the dataset <y> shows a significant change in its values and distribution compared to the previous refreshes. This variation indicates a drift in data, which may impact the accuracy of downstream pipelines, models, analytics and KPIs."
  },
  "Data Type Consistency": {
    "datasetTitle": "Attributes with Inconsistent Datatype: <z>%",
    "attributeTitle": "Data with inconsistent datatype: <z>%",
    "descriptionDataset": "<z%> of attributes in dataset <y> have values that are inconsistent with the expected data type. This may cause errors in processing and impact the reliability of the dataset.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has values that are inconsistent with the expected data type. This may cause errors in processing and impact the reliability of the dataset."
  },
  "Categorical Encode": {
    "datasetTitle": "Attributes with Inconsistent categorical values: <z>%",
    "attributeTitle": "Data with inconsistent categorical values: <z>%",
    "descriptionDataset": "<z%> of attributes in dataset <y> have values that are not part of the expected categories. This may lead to incorrect grouping, reporting, or downstream errors.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has values that are not part of the expected categories. These inconsistencies may lead to incorrect grouping, reporting, or downstream errors."
  },
  "Normalization Consistency": {
    "datasetTitle": "Attributes with Normalization inconsistency: <z>%",
    "attributeTitle": "Data with Normalization inconsistency: <z>%",
    "descriptionDataset": "<z%> of attributes in the dataset <y>, upon normalization, are not within the expected scale compared to the reference dataset <w>. This may impact model convergence and model performance.",
    "descriptionAttribute": "The attribute <x> in dataset <y>, upon normalization, has values that are not within the expected scale compared to the reference dataset <w>. This may impact model convergence and model performance."
  },
  "Boolean Conformity": {
    "datasetTitle": "Non-conformant Boolean data: <z>%",
    "attributeTitle": "Non-conformant Boolean data: <z>%",
    "descriptionDataset": "Dataset <y> has <z%> of values that are not valid boolean values. This may indicate incorrect data entry or format issues.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values that are not valid boolean entries. This may indicate incorrect data entry or format issues."
  },
  "Credit Card Conformity": {
    "datasetTitle": "Non-conformant Credit Card data: <z>%",
    "attributeTitle": "Non-conformant Credit Card data: <z>%",
    "descriptionDataset": "Dataset <y> contains <z%> of values that are not valid credit card numbers. This may cause financial processing and validation errors leading to failed transactions.",
    "descriptionAttribute": "The attribute <x> in dataset <y> contains <z%> of values that are not valid credit card numbers. This may cause financial processing and validation errors leading to failed transactions."
  },
  "Date Conformity": {
    "datasetTitle": "Non-conformant Date: <z>%",
    "attributeTitle": "Non-conformant Date: <z>%",
    "descriptionDataset": "Dataset <y> has <z%> of values that are not in the correct date format. This may cause issues in filtering, sorting, or time-based analysis and analytics.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values that are not in the correct date format. This may cause issues in filtering, sorting, or time-based analysis and analytics."
  },
  "Email Conformity": {
    "datasetTitle": "Non-conformant Email-ID: <z>%",
    "attributeTitle": "Non-conformant Email-ID: <z>%",
    "descriptionDataset": "Dataset <y> has <z%> of values that do not follow the correct email format. This may reduce the reliability in communication or identification purposes.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values that do not follow the correct email format. This may reduce the reliability in communication or identification purposes."
  },
  "Gender Conformity": {
    "datasetTitle": "Non-conformant Gender data: <z>%",
    "attributeTitle": "Non-conformant Gender data: <z>%",
    "descriptionDataset": "Dataset <y> has <z%> of values outside the expected gender categories. Such non-conformities may affect reporting and analysis accuracy.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values outside the expected gender categories. Such non-conformities may affect reporting and analysis accuracy."
  },
  "Http Conformity": {
    "datasetTitle": "Non-conformant HTTP data: <z>%",
    "attributeTitle": "Non-conformant HTTP data: <z>%",
    "descriptionDataset": "Dataset <y> has <z%> of values that are not valid or expected HTTP response codes.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values that are not valid or expected HTTP response codes."
  },
  "IP Conformity": {
    "datasetTitle": "Non-conformant IP Address: <z>%",
    "attributeTitle": "Non-conformant IP Address: <z>%",
    "descriptionDataset": "The dataset <y> has <z%> of values that don’t match the IP address format.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values that don’t match the IP address format."
  },
  "SSN Conformity": {
    "datasetTitle": "Non-conformant SSN data: <z>%",
    "attributeTitle": "Non-conformant SSN data: <z>%",
    "descriptionDataset": "The dataset <y> has <z%> of values that don’t follow the SSN format.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values that don’t follow the SSN format."
  },
  "URL Conformity": {
    "datasetTitle": "Non-conformant URL data: <z>%",
    "attributeTitle": "Non-conformant URL data: <z>%",
    "descriptionDataset": "The dataset <y> has <z%> of values that are not valid or complete URLs.",
    "descriptionAttribute": "The attribute <x> in dataset <y> has <z%> of values that are not valid or complete URLs."
  },
  "Incremental Data Identifier Wrong Datatype": {
    "datasetTitle": "Incremental Data Identifier has incorrect Datatype",
    "attributeTitle": null,
    "descriptionDataset": "Incremental Data Identifier helps identify the changeset in the refreshes of the dataset. It must be of datatype Date/Datetime (timestamp). The configured Incremental Data Identifier <x> in the dataset <y> is <current_data_type>. This prevents the profiling of the dataset and its attributes. This can be corrected by configuring the right Incremental Data Identifier for the dataset <y>.",
    "descriptionAttribute": null
  },
  "Incremental Data Identifier Not Found": {
    "datasetTitle": "Incremental Data Identifier not found",
    "attributeTitle": null,
    "descriptionDataset": "Incremental Data Identifier helps identify the changeset in the refreshes of the dataset. The configured Incremental Data Identifier <x> is not found in the Dataset <y>. This configuration will be ignored for profiling and monitoring the dataset <y> and its attributes. Reconfigure the right incremental column in the datasource settings to ensure the correct identification of the refreshes in the dataset <y>.",
    "descriptionAttribute": null
  },
  "Incorrect Starting Index": {
    "datasetTitle": "Starting Index has incorrect Datatype",
    "attributeTitle": null,
    "descriptionDataset": "Starting Identifier must be of datatype Date/Datetime (timestamp). The configured Starting Index <x> in dataset <y> is <current_data_type>. Profiling and incremental monitoring can't run correctly. Please set a valid Date/Datetime column as the Starting Index in the datasource settings.",
    "descriptionAttribute": null
  },
  "Datatype Mismatch": {
    "datasetTitle": "Datatype Mismatch",
    "attributeTitle": null,
    "descriptionDataset": "The starting index you configured for dataset <x> is not a valid date-type column. Select a column that stores dates/timestamps.",
    "descriptionAttribute": null
  },
  "Data Not Found For Value": {
    "datasetTitle": "Data Not Found For Value",
    "attributeTitle": null,
    "descriptionDataset": "The starting index value <starting_index_value> was not found in the selected date column for dataset <x>. Confirm the selected starting index date falls within the date range available in the dataset.",
    "descriptionAttribute": null
  },
  "Data Not Found For Query": {
    "datasetTitle": "Data Not Found For Query",
    "attributeTitle": null,
    "descriptionDataset": "No records are available for dataset <x> based on the configured starting index Query. Review the configured starting index and configure again. ",
    "descriptionAttribute": null
  },
  "Invalid Query": {
    "datasetTitle": "Invalid Query",
    "attributeTitle": null,
    "descriptionDataset": "The starting index query configured for dataset <x> is invalid. Review the configured query for Starting Index.",
    "descriptionAttribute": null
  },
  "Partition Identifier Not Found": {
    "datasetTitle": "Partition Identifier not found",
    "attributeTitle": null,
    "descriptionDataset": "Configuring 'Partition Identifier' enables profiling of a dataset in partitions. The configured Partition Identifier <pi> is not found in dataset <y>. Please update the Partition Identifier in the datasource settings to continue profiling the partitions.",
    "descriptionAttribute": null
  },
  "Empty Dataset": {
    "datasetTitle": "No new rows found",
    "attributeTitle": null,
    "descriptionDataset": "No new rows were found in dataset <y> at <generated_at> UTC. This could be due to configuration changes or pipeline issues. Please check if any changes are required in the configuration of the dataset.",
    "descriptionAttribute": null
  },
  "New Attributes Found": {
    "datasetTitle": "New Attribute Found",
    "attributeTitle": null,
    "descriptionDataset": "New attributes were detected in the dataset <y> during the latest refresh. The list below shows the attributes that were added, along with their datatypes. These changes may affect downstream pipelines, analytics, models, or integrations that depend on the dataset structure. If the same schema change continues for 3 consecutive refreshes, it will be treated as part of the base schema.",
    "descriptionAttribute": null
  },
  "Existing Attributes Deleted": {
    "datasetTitle": "Missing Attribute",
    "attributeTitle": null,
    "descriptionDataset": "Existing attributes were not found in the dataset <y> during the latest refresh. The list below shows the attributes that were deleted, along with their datatypes. These changes may affect downstream pipelines, analytics, models, or integrations that depend on the dataset structure. If the same schema change continues for 3 consecutive refreshes, it will be treated as part of the base schema.",
    "descriptionAttribute": null
  },
  "Attributes With Datatype Changed": {
    "datasetTitle": "Changed Datatype in attribute",
    "attributeTitle": null,
    "descriptionDataset": "Datatype changes were detected in the dataset <y> during the latest refresh. The list below shows the affected attributes, along with their old and new datatypes. These changes may affect downstream pipelines, analytics, models, or integrations that depend on the dataset structure. If the same schema change continues for 3 consecutive refreshes, it will be treated as part of the base schema.",
    "descriptionAttribute": null
  },
  "Host Unreachable": {
    "datasetTitle": "Datasource not reachable",
    "attributeTitle": null,
    "descriptionDataset": "Could not establish connection with the host <host> for datasource <z>. There was no response or the connection was blocked. This could be due to incorrect connection details or restricted IP access in the host. Please check the connection details configured and ensure that the IP address <ip> is whitelisted correctly.",
    "descriptionAttribute": null
  },
  "Deleted Dataset": {
    "datasetTitle": "Dataset deleted or missing",
    "attributeTitle": null,
    "descriptionDataset": "Cannot find dataset <y> in the datasource <m>. It looks like the dataset was deleted or moved. Please restore the dataset or update the configuration to the correct path/schema/table.",
    "descriptionAttribute": null
  },
  "Incorrect Credentials": {
    "datasetTitle": "Incorrect credentials for datasource",
    "attributeTitle": null,
    "descriptionDataset": "Cannot connect to <connection/source> for datasource <m> as the saved credentials are invalid or expired. Please update the details in the datasource configuration and try again.",
    "descriptionAttribute": null
  },
  "Schema Not Found": {
    "datasetTitle": "Schema not found in datasource",
    "attributeTitle": null,
    "descriptionDataset": "Cannot find the schema <schema> in datasource <m>. Please update the details in the datasource configuration and try again.",
    "descriptionAttribute": null
  },
  "Failed Runs": {
    "datasetTitle": "Pipeline Run Failed",
    "attributeTitle": null,
    "descriptionDataset": "Pipeline run <run_id> for <pipeline_source_name> failed at <generated_at> configured from <pipeline_source_name>. Total duration: <run_time> ms. Review failed activity logs to identify the exact cause and re-run the pipeline.",
    "descriptionAttribute": null
  },
  "Failed Stages": {
    "datasetTitle": "Pipeline Stage Failed",
    "attributeTitle": null,
    "descriptionDataset": "Stage <stage_name> in run <run_id> for source <pipeline_source_name> failed at <time> after running for a duration of <stage_run_time>.  This could be due to drift in data volume or insufficient resources or changes in schema.  Please rerun the pipeline after fixing any issues.",
    "descriptionAttribute": null
  },
  "Delayed Runs": {
    "datasetTitle": "Delay in Pipeline Run",
    "attributeTitle": null,
    "descriptionDataset": "The scheduled run for <pipeline_name> did not start on time. This indicates a potential trigger failure, upstream dependency delay, or scheduler issue requiring attention.",
  },

  "Missed Runs": {
    "datasetTitle": "Missed Pipeline Run",
    "attributeTitle": null,
    "descriptionDataset": "A scheduled pipeline run was missed for <pipeline_name>. The job did not start at its designated time and requires verification.",
  },

  "Long Running Pipeline": {
    "datasetTitle": "Long Running Pipeline",
    "attributeTitle": null,
    "descriptionDataset": "The run for <pipeline_name> is taking longer than its expected execution time. This may indicate processing delays, resource constraints, or an issue within the pipeline that requires attention",
  },
  "conformity_custom": {
    "datasetTitle": "<custom_metric_name> failed to meet requirements",
    "attributeTitle": null,
    "descriptionDataset": "The custom metric <custom_metric_name> value is <z> which is <more_less> than the configured threshold of <y>",
    "descriptionAttribute": null
  },
}

/**
 * Replace placeholders in template with actual values
 * Handles <placeholder> and <placeholder%>
 */
export function fillTemplate(template, values) {
  if (!template) return null;

  return template.replace(/<([^>]+)>/g, (_, expr) => {
    // If it's a simple variable, just replace as before
    if (expr === "verb") {
      const count = Number(values.z) || 0;
      return count === 1 ? "has" : "have";
    }
    if (expr === "pronoun") {
      const count = Number(values.z) || 0;
      return count === 1 ? "its" : "their";
    }
    if (/^[a-zA-Z0-9_]+%?$/.test(expr)) {
      let isPercent = false;
      let cleanKey = expr;
      if (expr.endsWith("%")) {
        isPercent = true;
        cleanKey = expr.slice(0, -1);
      }
      let value = values[cleanKey];
      if (value == null) return `<${expr}>`;
      if (isPercent && typeof value === "number") {
        return `${value}%`;
      }
      return value;
    }
    // If it's an arithmetic expression like 100-x
    try {
      // Replace variable names in the expression with their values
      let evalExpr = expr.replace(/[a-zA-Z_][a-zA-Z0-9_]*/g, (v) => {
        if (values[v] == null) return `0`;
        return values[v];
      });
      // eslint-disable-next-line no-eval
      let result = eval(evalExpr);
      return result;
    } catch (e) {
      return `<${expr}>`;
    }
  });
}

/**
 * Build title/description for a given subtype with runtime values
 * @param {string} subtype
 * @param {object} values
 * @returns {object}
 */
export function buildIncidentText(subtype, values = {}) {
  const t = templates[subtype];
  if (!t) {
    return {
      datasetTitle: "",
      datasetDescription: "",
      attributeTitle: "",
      attributeDescription: ""
    };
  }
  return {
    datasetTitle: fillTemplate(t.datasetTitle, values),
    datasetDescription: fillTemplate(t.descriptionDataset, values),
    attributeTitle: fillTemplate(t.attributeTitle, values),
    attributeDescription: fillTemplate(t.descriptionAttribute, values)
  };
}

/**
 * Replace placeholders in template with actual values (React version)
 * Handles <placeholder> and <placeholder%>
 * For <z%>, returns <span className="text-danger">...</span>
 */
export function fillTemplateReact(template, values) {
  if (!template) return null;
  const parts = [];
  let lastIndex = 0;
  const regex = /<([^>]+)>/g;
  let match;
  let key = 0;
  while ((match = regex.exec(template)) !== null) {
    // Push preceding text
    if (match.index > lastIndex) {
      parts.push(template.slice(lastIndex, match.index));
    }
    const expr = match[1];
    // If it's a simple variable, just replace as before
    if (/^[a-zA-Z0-9_]+%?$/.test(expr)) {
      let isPercent = false;
      let cleanKey = expr;
      // Handles <z%> and <z>% (the latter is not in template, but let's support)
      if (expr.endsWith("%")) {
        isPercent = true;
        cleanKey = expr.slice(0, -1);
      }
      let value = values[cleanKey];
      if (value == null) {
        parts.push(match[0]);
      } else if (typeof value === "number") {
        // Always wrap numbers in <span className="text-danger">
        parts.push(
          <span className="text-danger" key={key++}>
            {isPercent ? `${value}%` : value}
          </span>
        );
      } else if (isPercent) {
        parts.push(
          <span className="text-danger" key={key++}>
            {value}
          </span>
        );
      } else {
        parts.push(value);
      }
    } else if (/^[a-zA-Z0-9_]+%$/.test(expr + "%")) {
      // Handles <z>% (if template has <z> followed by % outside)
      let cleanKey = expr;
      let value = values[cleanKey];
      if (value == null) {
        parts.push(match[0]);
      } else {
        parts.push(
          <span className="text-danger" key={key++}>
            {value}%
          </span>
        );
      }
    } else {
      // If it's an arithmetic expression like 100-x
      try {
        let evalExpr = expr.replace(/[a-zA-Z_][a-zA-Z0-9_]*/g, (v) => {
          if (values[v] == null) return `0`;
          return values[v];
        });
        // eslint-disable-next-line no-eval
        let result = eval(evalExpr);
        parts.push(result);
      } catch (e) {
        parts.push(match[0]);
      }
    }
    lastIndex = regex.lastIndex;
  }
  // Push remaining text
  if (lastIndex < template.length) {
    parts.push(template.slice(lastIndex));
  }
  return parts;
}

/**
 * Build title/description for a given subtype with runtime values (React version)
 * @param {string} subtype
 * @param {object} values
 * @returns {object}
 */
export function buildIncidentTextReact(subtype, values = {}) {
  const t = templates[subtype];
  if (!t) {
    return {
      datasetTitle: "",
      datasetDescription: "",
      attributeTitle: "",
      attributeDescription: ""
    };
  }
  return {
    datasetTitle: fillTemplateReact(t.datasetTitle, values),
    datasetDescription: fillTemplateReact(t.descriptionDataset, values),
    attributeTitle: fillTemplateReact(t.attributeTitle, values),
    attributeDescription: fillTemplateReact(t.descriptionAttribute, values)
  };
}
